import { Component, OnInit } from "@angular/core";
import moment from "moment";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { CookieService } from "ngx-cookie-service";
import { HelpComponent } from "../../Misc/help.component";
import { BaseUrlHelperService } from "../../shared/helper/baseUrlHelper.service";

@Component({
    selector: "common-layout",
    templateUrl: "./common-layout.component.html",
    standalone: false
})
export class CommonLayoutComponent implements OnInit {
    constructor(
        private baseAPi: BaseUrlHelperService,
        private _modalService: BsModalService,
        private cookieService: CookieService
    ) {}

    title = "common layout";
    bsModalRef?: BsModalRef;
    padUrl = window.preload.uisettings.pickaDoorUrl;
    user: any = window.preload.user;

    openOlympicsHelpModel() {
        const initialState: any = {
            hideConfirm: false,
            fullName: this.user,
        };
        const modalOptions = {
            animated: true,
            keyboard: false,
            backdrop: true,
            ignoreBackdropClick: true,
            initialState: initialState,
        };
        this.bsModalRef = this._modalService.show(HelpComponent, modalOptions);
    }
    onBrandClick() {
        window.location = this.padUrl;
    }

    logout() {
        window.localStorage.clear();
        this.cookieService.deleteAll();
        window.location.href = window.location.origin + "/api/logout";
    }

    ngOnInit() {
        this.user = window ? window.preload.user : null;
        //date conversion
        this.user.lastLogin = this.user.lastLogin
            ? moment.utc(this.user.lastLogin).local().format("llll")
            : "";
    }
}
